// import enum
export const state = {
  filter: {
    keyword: "",
    // contact_email: "",
    status: [],
    isFilter: false,
  },
};
export const mutations = {
  addFilterTechProducts: (state, data) => {
    state.filter = data;
    state.filter.isFilter = true;
  },
  clearFilterTechProducts: (state) => {
    state.filter = {
      keyword: "",
      // contact_email: "",
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_TECH_PRODUCTS: (state) => {
    return state.filter;
  },
};
export const actions = {
  ADD_FILTER_TECH_PRODUCTS: ({ commit }, data) => {
    commit("addFilterTechProducts", data);
  },
  CLEAR_FILTER_TECH_PRODUCTS: ({ commit }) => {
    commit("clearFilterTechProducts");
  },
};
